import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class RolesService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/common-ucenter-server/api'
  };
  // 获取所有资源列表
  getResources() {
    return this.get('/featureResources?productCode=chat-bot');
  }
  // 创建角色
  createRoule(data: any) {
    return this.post('/featureRoles', data);
  }
  // 编辑角色
  editRoule(id: any, data: any) {
    return this.put(`/featureRoles/${id}`, data);
  }
  // 获取角色列表
  getRoules(data: any) {
    return this.get('/featureRoles', data);
  }
  // 删除角色
  deleteRoule(id: any) {
    return this.delete(`/featureRoles/${id}`);
  }
  // 停用角色
  disableRoule(id: any) {
    return this.post(`/featureRoles/${id}/disable`);
  }
  //启用角色
  enableRoule(id: any) {
    return this.post(`/featureRoles/${id}/enable`);
  }
  // 获取角色详情
  getRoule(id: any) {
    return this.get(`/featureRoles/${id}`);
  }
  // 获取用户列表
  getUers(data: any) {
    return this.get('/b/users', data);
  }
  // 新建用户
  createUer(data: any) {
    return this.post('/b/users/add', data);
  }
  // 删除用户
  deleteUer(data: any) {
    return this.delete('/b/users/batchDelete', { data: data });
  }
  // 查询用户详情
  getUserDetails(id: any) {
    return this.get(`/b/users/${id}`);
  }
  // 分配角色
  addRouleToUser(data: any) {
    return this.post(`/b/userIdentities`, data);
  }
  // 修改用户身份
  updateRouleToUser(data: any) {
    return this.put(`/b/userIdentities`, data);
  }
}
export default new RolesService();
